import AgentHubAccountMenu from 'agentHub/components/AgentHubAccountMenu'
import AgentHubCustomerViewSwitch from 'agentHub/components/AgentHubCustomerViewSwitch'
import NavBarCartButton from 'components/NavKit/NavBarButtons/NavBarCartButton'
import NavBarLoginButton from 'components/NavKit/NavBarButtons/NavBarLoginButton'
import NavBarNotificationsButton from 'components/NavKit/NavBarButtons/NavBarNotificationsButton'
import NavBarTripButton from 'components/NavKit/NavBarButtons/NavBarTripButton'
import NavBarUserButton from 'components/NavKit/NavBarButtons/NavBarUserButton'
import Group from 'components/utils/Group'
import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React from 'react'
import { selectLoggedIn } from 'selectors/accountSelectors'
import styled from 'styled-components'

const CondensedNavBarUserButton = styled(NavBarUserButton)`
  padding-block: ${rem(4)};
`

interface Props {
  className?: string
}

/**
 * This is a temporary implementation for map search nav items,
 * until designs are final.
 */
function MapSearchNav({ className }: Props) {
  const isLoggedIn = useAppSelector(selectLoggedIn)

  return <Group direction="horizontal" verticalAlign="center" gap={8} className={className}>
    <NavBarTripButton contentBreakpointMax="mobile" />
    {isLoggedIn && <>
      {config.agentHub.isEnabled && <AgentHubCustomerViewSwitch />}
      {config.agentHub.isEnabled && <AgentHubAccountMenu />}
      <NavBarNotificationsButton />
      <NavBarCartButton />
      <CondensedNavBarUserButton />
    </>}
    {!isLoggedIn && <NavBarLoginButton />}
  </Group>
}

export default MapSearchNav
